import { CardBody, Image, VStack } from "@chakra-ui/react";
import CDS from "design-system";
import AppPage from "layouts/AppPage";
import TransparentCard from "components/Card/TransparentCard";
import BeachDaySVG from "assets/undraw_beach_day.svg";

export default function PortalDisabledState() {
  return (
    <AppPage>
      <TransparentCard>
        <CardBody>
          <VStack spacing={6} align="center" textAlign="center" py={8}>
            <Image mx={6} maxWidth="320px" maxHeight="320px" src={BeachDaySVG} />
            <VStack spacing={2}>
              <CDS.Text18 fontWeight="semibold" color="content.primary">
                Your portal isn&apos;t available with a personal account
              </CDS.Text18>
              <CDS.Text14 color="content.tertiary">
                Your company requires a work account to access onboarding. Reach out to your hiring contact
                if you need help getting started.
              </CDS.Text14>
            </VStack>
          </VStack>
        </CardBody>
      </TransparentCard>
    </AppPage>
  );
}
